import { render, staticRenderFns } from "./SalesChannelPromotions.vue?vue&type=template&id=42840720&"
import script from "./SalesChannelPromotions.vue?vue&type=script&lang=js&"
export * from "./SalesChannelPromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports